module.exports = VueI18n;


//////////////////
// WEBPACK FOOTER
// external "VueI18n"
// module id = Av8/
// module chunks = 1